'use strict';

var SET_IS_POST_LOADING = 'SET_IS_POST_LOADING';
var FETCH_POSTS = 'FETCH_POSTS';
var SELECT_POST = 'SELECT_POST';
var SET_FILTER = 'SET_FILTER';
var FETCH_POST = 'FETCH_POST';
var SEARCH_SUCCESS = 'SEARCH_SUCCESS';
var SEARCH_FAILED = 'SEARCH_FAILED';
var GET_ALL_TAGS = 'GET_ALL_TAGS';
var NEW_POST = 'NEW_POST';
var IMAGE_UPLOAD = 'IMAGE_UPLOAD';

exports.FETCH_POST = FETCH_POST;
exports.FETCH_POSTS = FETCH_POSTS;
exports.GET_ALL_TAGS = GET_ALL_TAGS;
exports.IMAGE_UPLOAD = IMAGE_UPLOAD;
exports.NEW_POST = NEW_POST;
exports.SEARCH_FAILED = SEARCH_FAILED;
exports.SEARCH_SUCCESS = SEARCH_SUCCESS;
exports.SELECT_POST = SELECT_POST;
exports.SET_FILTER = SET_FILTER;
exports.SET_IS_POST_LOADING = SET_IS_POST_LOADING;
